require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-peppa-pig-world.json") })
        }
      }, "path---authors-peppa-pig-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-peppa-pig-world!./.cache/json/authors-peppa-pig-world.json
// module id = 1325
// module chunks = 231608221292675